import OnboardingGreeting from '@/components/domains/self-service/onboarding/OnboardingGreeting.vue';
import OnboardingInputCountAttendee from '@/components/domains/self-service/onboarding/OnboardingInputCountAttendee.vue';
import OnboardingInputNameRoom from '@/components/domains/self-service/onboarding/OnboardingInputNameRoom.vue';
import OnboardingInputNickname from '@/components/domains/self-service/onboarding/OnboardingInputNickname.vue';
import OnboardingReady from '@/components/domains/self-service/onboarding/OnboardingReady.vue';
import OnboardingSelectInterpretation from '@/components/domains/self-service/onboarding/OnboardingSelectInterpretation.vue';
import OnboardingSelectLanguage from '@/components/domains/self-service/onboarding/OnboardingSelectLanguage.vue';
import OnboardingUserAgreement from '@/components/domains/self-service/onboarding/OnboardingUserAgreement.vue';
import IconAudience from '@/components/icons/IconAudience.vue';
import IconChart from '@/components/icons/IconChart.vue';
import IconCompanyManage from '@/components/icons/IconCompanyManage.vue';
import IconEdit from '@/components/icons/IconEdit.vue';
import IconExit from '@/components/icons/IconExit.vue';
import IconHelp from '@/components/icons/IconHelp.vue';
import IconHistory from '@/components/icons/IconHistory.vue';
import IconSingle from '@/components/icons/IconSingle.vue';
import IconTextSearch from '@/components/icons/IconTextSearch.vue';
import IconUsers from '@/components/icons/IconUsers.vue';
import IconUserVoice from '@/components/icons/IconUserVoice.vue';
import {
  ISelfServiceOnboardingForm,
  ISelfServiceMenuItem,
  ISelfServiceOnboardingStep,
  ProfileOption,
  ISelfServiceSideMenu,
} from '@/types/components';

export const SELF_SERVICE_MENU: ISelfServiceSideMenu[] = [
  {
    titleKey: 'label_interpretation',
    usingDivider: true,
    menuItems: [
      // 컨퍼런스
      {
        titleKey: 'label_conference',
        iconComponent: IconUserVoice,
        routePath: '/ss/chat/conference',
        accessUserTypes: ['HOST', 'SUB'],
        accessPlanTypes: [],
      },
      // 미팅
      {
        titleKey: 'label_meeting',
        iconComponent: IconCompanyManage,
        routePath: '/ss/chat/meeting',
        accessUserTypes: ['HOST', 'SUB'],
        accessPlanTypes: [],
      },
      // 청취
      {
        titleKey: 'label_audience',
        iconComponent: IconAudience,
        routePath: '/ss/chat/audience',
        accessUserTypes: ['HOST', 'SUB'],
        accessPlanTypes: [],
      },
      // 대화
      {
        titleKey: 'label_general',
        iconComponent: IconUsers,
        routePath: '/ss/chat/general',
        accessUserTypes: ['HOST', 'SUB'],
        accessPlanTypes: [],
      },
      // 싱글
      {
        titleKey: 'label_single',
        iconComponent: IconSingle,
        routePath: '/ss/chat/single',
        accessUserTypes: ['HOST', 'SUB'],
        accessPlanTypes: [],
      },
      // 나의 통역
      {
        titleKey: 'my_interpreter',
        iconComponent: IconHistory,
        routePath: '/ss/chat/list',
        accessUserTypes: ['HOST', 'SUB'],
        accessPlanTypes: [],
      },
    ],
  },
  {
    titleKey: 'label_settings',
    usingDivider: true,
    menuItems: [
      // 사용 이력
      {
        titleKey: 'interpretation_history',
        iconComponent: IconTextSearch,
        routePath: '/ss/chat/history',
        accessUserTypes: ['HOST', 'SUB'],
        accessPlanTypes: [],
      },
      // 구독 관리
      {
        titleKey: 'plan_setting',
        iconComponent: IconChart,
        routePath: '/ss/plan/manage',
        accessUserTypes: ['HOST'],
        accessPlanTypes: [],
      },
    ],
  },
];

export const SELF_SERVICE_DROPDOWN_MENU: ISelfServiceMenuItem[] = [
  // 고객센터
  {
    titleKey: 'support_center',
    iconComponent: IconHelp,
    routePath: '/ss/contact',
    accessUserTypes: ['HOST', 'SUB'],
    accessPlanTypes: [],
  },
  // 내 정보 수정
  {
    titleKey: 'label_edit_my_info',
    iconComponent: IconEdit,
    routePath: '/ss/account/edit',
    accessUserTypes: ['HOST', 'SUB'],
    accessPlanTypes: [],
  },
  // 로그아웃
  {
    titleKey: 'button_logout',
    iconComponent: IconExit,
    routePath: '',
    accessUserTypes: ['HOST', 'SUB'],
    accessPlanTypes: [],
  },
];

export const ONBOARDING_STEP_MAP: ISelfServiceOnboardingStep[] = [
  // 약관동의
  {
    stepKey: 'AGREEMENT',
    component: OnboardingUserAgreement,
    validateKey: ['countryCode', 'isAgreedUsage', 'isAgreedPersonal', 'isAgreedPayment'],
    nextButtonKey: 'next',
  },
  // 소개
  {
    stepKey: 'GREETING',
    component: OnboardingGreeting,
    validateKey: [],
    nextButtonKey: 'next',
  },
  // 사용자 닉네임
  {
    stepKey: 'NICKNAME',
    component: OnboardingInputNickname,
    validateKey: ['nickname'],
    nextButtonKey: 'next',
  },
  // 언어 선택
  {
    stepKey: 'LANGUAGE',
    component: OnboardingSelectLanguage,
    validateKey: ['languageCode'],
    nextButtonKey: 'next',
  },
  // 원하는 통역 모드
  {
    stepKey: 'INTERPRETATION',
    component: OnboardingSelectInterpretation,
    validateKey: ['callType'],
    nextButtonKey: 'next',
  },
  // 최대 참석자 수
  {
    stepKey: 'ATTENDEE',
    component: OnboardingInputCountAttendee,
    validateKey: ['maxParticipants'],
    nextButtonKey: 'next',
  },
  // 통역방 이름
  {
    stepKey: 'CHAT_NAME',
    component: OnboardingInputNameRoom,
    validateKey: ['title'],
    nextButtonKey: 'next',
  },
  // 통역 준비 완료
  {
    stepKey: 'READY',
    component: OnboardingReady,
    validateKey: [],
    nextButtonKey: 'onboarding_begin_translation',
  },
  // TODO: 추후 추가 항목
  // OnboardingSelectImageUser, // 통역방 이미지
  // OnboardingSelectImageUser, // 사용자 프로필 이미지
  // OnboardingReadyProfile, // 사용자 프로필 준비완료
  // OnboardingSelectRoleGuest, // 게스트 발화 가능 여부
  // OnboardingSelectModeScreen, // 스크린 모드 필요 여부
];

export const defaultOnboardingForm: ISelfServiceOnboardingForm = {
  // 약관동의
  isAgreedUsage: false,
  isAgreedPersonal: false,
  isAgreedPayment: false,
  isAgreedStorage: false,
  isAgreedMarketing: false,

  // 사용자 정보
  referralCode: '', // 추천인 코드
  countryCode: '', // 접속국가
  languageCode: 'en_US', // 언어코드
  nickname: '', // 사용자 닉네임

  // 통역방 정보
  id: '',
  callType: '', // 원하는 통역 모드
  maxParticipants: 0, // 최대 참석자 수
  title: '', // 통역방 이름
  callLogoImage: {} as ProfileOption, // 통역방 이미지
  callLogoBackgroundColor: 'navy', // 통역방 배경색깔
};
